import { LinkedTargetOption } from '../hooks/use-linked-target-options.hook';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const isUuid = (value: string) => UUID_PATTERN.test(value);

export const resolveLinkedEventDisplayLabel = ({
  linkedEventLabel,
  linkedTargetId,
  options,
}: {
  linkedEventLabel?: null | string;
  linkedTargetId?: null | string;
  options: LinkedTargetOption[];
}): string | undefined => {
  if (linkedTargetId) {
    const fromOptions = options.find((option) => option.id === linkedTargetId)?.label?.trim();
    if (fromOptions) {
      return fromOptions;
    }
  }

  const trimmedLabel = linkedEventLabel?.trim();
  if (!trimmedLabel || trimmedLabel === '-') {
    return undefined;
  }

  if (linkedTargetId && trimmedLabel === linkedTargetId) {
    return undefined;
  }

  if (isUuid(trimmedLabel)) {
    return undefined;
  }

  return trimmedLabel;
};
